var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"order-btn",class:_vm.classes,attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('tl-icon',{attrs:{"icon":"spinner","spin":""}}):_c('span',[_vm._v(_vm._s(_vm.$t(_vm.label)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }